import script from "./PDFReader.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFReader.vue?vue&type=script&setup=true&lang=js"

import "./PDFReader.vue?vue&type=style&index=0&id=429ad5bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-429ad5bc"]])

export default __exports__